import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ButtonMiTelcel from "../../atoms/ButtonMiTelcel";
import { getHasDomiciliation } from "../../../store/actions/domiciliation";
import ModalCardLoader from "../ModalCardLoader";
import HasDomiciliationModal from "../HasDomiciliationModal";
import { isObjectEmpty } from "../../organisms/utils";
import { executeTaggeo, getPaymentMethods } from "../../../store/actions";
import * as sdkclaro from '@claropay/claro-pay-sdk-v2';
import {
  URL_APPLE_STORE,
  URL_PLAY_STORE,
} from '../../../constants';
import {
  getMessage,
  validateUserAgent,
} from "../../organisms/utils";
import ModalCardOk from "../../molecules/ModalCardOk";
import { getDomiciliationWindowId } from "../../organisms/utils";

export default class SchedulePaymentButton extends Component {
  constructor(props) {
    super(props);
    this.schedulePaymentbuttonRef = React.createRef();
    this.state = {
      openHasDomiciliationModal: false,
      CpMessage: "CP0005",
      isNewValidateDomiciliationRequest: false,
      upsellCreate: false,
      getSearchCard: false,
      getUpsellEnd: false,
      countPaymentMethodsCall: 0,
    };
  }

  componentDidUpdate(prevProps) {
    const { isLoadingGetPaymentMethods, errorPaymentMethods } = this.props;
    if (this.state.upsellCreate && !this.state.getSearchCard) {
      this.setState({ getSearchCard: true });
      this.props.getPaymentMethods(this.props.serviceId, false);
    }
    if (prevProps.isLoadingGetPaymentMethods && !isLoadingGetPaymentMethods) {
      if (errorPaymentMethods && !this.state.getUpsellEnd) {
        if (this.state.countPaymentMethodsCall < 2) {
          this.setState({ modalUpdateAppInformation: getMessage(this.props.messages, "CP0019"), countPaymentMethodsCall: this.state.countPaymentMethodsCall + 1 })
          this.props.getPaymentMethods(this.props.serviceId, false);
        } else {
          this.setState({
            openModalUpdateApp: true,
            getUpsellEnd: true
          });
        }
      } else {
        setTimeout(() => {
          if (
            this.schedulePaymentbuttonRef &&
            this.schedulePaymentbuttonRef.current && !this.state.getUpsellEnd && this.state.getSearchCard
          ) {
            this.schedulePaymentbuttonRef.current.click();
            sessionStorage.setItem("domiciliationUpsell", true)
            this.setState({ getUpsellEnd: true });
          }
        }, 500);
      }
    }
  }

  handleUpsellN2 = (paramsKey) => {
    const params = { requestCode: getDomiciliationWindowId(paramsKey), serviceName: this.props.tagServiceId };
    const url = {
      app: "startEventNoClose",
      to: "openUpSellN2",
      parameters: JSON.stringify(params),
    };

    sdkclaro.getInstance().openNative(
      JSON.stringify(url),
      () => { },
      () => { }
    );
  };

  handleModalUpdate = () => {
    this.setState({
      openModalUpdateApp: true,
      modalUpdateAppInformation: getMessage(this.props.messages, "CP0021"),
    });
  };

  handleOnClick = () => {
    const { paymentMethods, canUpsellN2 } = this.props
    const { hasN2, hasNIP } = paymentMethods;
    if (!hasN2) {
      if (!canUpsellN2) {
        this.handleModalUpdate();
      } else {
        this.handleUpsellN2("NOT_N2");
      }
    } else if (hasN2 && !hasNIP) {
      if (!canUpsellN2) {
        this.handleModalUpdate();
      } else {
        this.handleUpsellN2("N2_NOT_NIP");
      }
    } else {
      const {
        lineNumber,
        serviceId,
        getHasDomiciliation,
        executeTaggeo,
        tagServiceId,
      } = this.props;
      this.setState({ isNewValidateDomiciliationRequest: true });
      getHasDomiciliation(lineNumber, serviceId);
      executeTaggeo({
        action: "Click Domiciliar",
        step: "Pantalla principal",
        service: tagServiceId,
        eventName: "telcel",
      });
    }
  };

  handleOnClickModalUpdateApp = (e) => {
    if (this.state.getUpsellEnd) {
      this.setState({ openModalUpdateApp: false })
    } else {
      const { innerText } = e.target;
      if (innerText == "Hacerlo en otro momento") {
        this.setState({
          openModalUpdateApp: false
        });
      }
      if (innerText == "Actualizar") {
        const linkInformation = JSON.stringify({
          app: "https",
          url:
            validateUserAgent() === "android" ? URL_PLAY_STORE : URL_APPLE_STORE,
        });
        sdkclaro.getInstance().openNative(
          linkInformation,
          () => { },
          () => { }
        );
      }
    }
  };
  render() {
    const {
      amount,
      hasDmResponse,
      isLoadingServiceDomiciliation,
      hasDmError,
      history,
      tagServiceId,
      lineNumber,
      goToDomiciliationForm,
      serviceId,
      isContainerTelcel,
    } = this.props;
    const { isNewValidateDomiciliationRequest, openModalUpdateApp, modalUpdateAppInformation } = this.state;
    const bottonIsValid = amount > 0 || goToDomiciliationForm;
    setTimeout(() => {
      if (
        !isObjectEmpty(hasDmResponse) &&
        !hasDmResponse.data.domiciliation &&
        goToDomiciliationForm &&
        this.schedulePaymentbuttonRef.current &&
        goToDomiciliationForm !== tagServiceId
      ) {
        this.schedulePaymentbuttonRef.current.click();
      }
    }, 500);

    setTimeout(() => {
      if (goToDomiciliationForm &&
        goToDomiciliationForm === tagServiceId &&
        this.schedulePaymentbuttonRef.current && !this.state.upsellCreate &&
        sessionStorage.getItem("domiciliationUpsell") !== "true"
      ) {
        this.setState({ upsellCreate: true })
      }
    }, 500);
    return (
      <>
        <ButtonMiTelcel
          height={"3.5em"}
          backgroundColor="#fff"
          margin={"0px auto"}
          width={"-webkit-fill-available"}
          padding={isContainerTelcel ? "11px 9px" : "8px 15px"}
          fontSize={isContainerTelcel ? "16px" : "12px"}
          style={{
            display: "flex",
            justifyContent: "center",
            background: bottonIsValid ? "#fff" : "#ccc",
            color: isContainerTelcel ? (bottonIsValid ? "#7B1FA2" : "#595959") : (bottonIsValid ? "#000" : "#999"),
            border: isContainerTelcel ? (bottonIsValid ? "1px solid #7B1FA2" : "1px solid #d0d0d0") : (bottonIsValid ? "1px solid black" : "1px solid #ccc"),
          }}
          disabled={!bottonIsValid}
          onClick={() => {
            this.handleOnClick();
          }}
          innerRef={this.schedulePaymentbuttonRef}
        >
          Domiciliar
        </ButtonMiTelcel>
        <ModalCardLoader isOpen={isLoadingServiceDomiciliation} />
        {(isNewValidateDomiciliationRequest &&
          !isLoadingServiceDomiciliation &&
          !isObjectEmpty(hasDmResponse)) ||
          (!isLoadingServiceDomiciliation && hasDmError) ? (
          <HasDomiciliationModal
            hasDmResponse={hasDmResponse}
            hasDmError={hasDmError}
            history={history}
            accountValue={lineNumber}
            amount={String(amount)}
            tagServiceId={tagServiceId}
            serviceId={serviceId}
            isContainerTelcel={isContainerTelcel}
          />
        ) : (
          <></>
        )}
        {openModalUpdateApp && modalUpdateAppInformation ? (
          <ModalCardOk
            isOpen={openModalUpdateApp}
            paddingCard={isContainerTelcel ? "16px 36px 50px 36px" : "16px"}
            marginCard={isContainerTelcel ? "16px" : "8px"}
            srcImage={modalUpdateAppInformation.data.icon}
            text={modalUpdateAppInformation.data.subject}
            textdetail={modalUpdateAppInformation.data.message}
            buttontext={modalUpdateAppInformation.data.buttons[0]}
            backgroundColorButton={isContainerTelcel ? "#7B1FA2" : "#000000"}
            fontSizeDetail={isContainerTelcel ? "16px" : "20px"}
            marginTextDetail={isContainerTelcel ? "16px 0px 35px 0px" : undefined}
            colorButton={isContainerTelcel ? "#ffffff" : "#ffffff"}
            fontFamilyButton="AMX-Bold"
            fontSizeButton={isContainerTelcel ? "16px" : "16px"}
            widthButton={isContainerTelcel ? "95%" : "100%"}
            heightButton={isContainerTelcel ? "45px" : "43px"}
            marginButton={"0px 0px 25px 0px"}
            paddingButton={"2px 10px 0px 10px"}
            onclickModal={this.handleOnClickModalUpdateApp}
            fontSizeTitle={isContainerTelcel ? "20px" : "18px"}
            fontFamilyTitle={"AMX-Bold"}
            textLink={modalUpdateAppInformation.data.buttons[1]}
            fontFamilyLinkButton={"AMX-Bold"}
            textSizeLinkButton={isContainerTelcel ? "16px" : "16px"}
            textColorLinkButton={isContainerTelcel ? "#1470D1" : "#000000"}
          />
        ) : (
          <></>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  const {
    domiciliationReducer: {
      hasDomiciliationServiceResponseError,
      hasDomiciliationServiceResponseSuccess,
      isLoadingServiceDomiciliation,
      goToDomiciliationForm,
      canUpsellN2
    },
    payments: { paymentMethods, messages = [], isLoadingGetPaymentMethods, errorPaymentMethods }
  } = state;

  return {
    errorPaymentMethods: errorPaymentMethods,
    paymentMethods: paymentMethods,
    canUpsellN2,
    messages,
    isLoadingGetPaymentMethods,
    hasDmError: hasDomiciliationServiceResponseError,
    isLoadingServiceDomiciliation,
    hasDmResponse: hasDomiciliationServiceResponseSuccess,
    goToDomiciliationForm,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getHasDomiciliation,
      getPaymentMethods,
      executeTaggeo,
    },
    dispatch
  );
}

SchedulePaymentButton = connect(
  mapStateToProps,
  mapDispatchToProps
)(SchedulePaymentButton);
